import React from 'react';
import styled from 'styled-components';

export const Section = styled.section`
  position: relative;
  padding: 120px 24px;
  overflow: hidden;
`;

export const Container = styled.div`
  max-width: ${({ theme }) => theme.layout.maxWidth};
  margin: 0 auto;
  width: 100%;
  position: relative;
  z-index: 1;
`;

const Head = styled.div`
  text-align: center;
  margin-bottom: 60px;
`;

const Kicker = styled.div`
  font-family: ${({ theme }) => theme.fonts.mono};
  font-size: 13px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.primarySoft};
  margin-bottom: 12px;
`;

const Title = styled.h2`
  font-size: clamp(32px, 5vw, 52px);
  font-weight: 700;

  .grad {
    background: linear-gradient(135deg, #A78BFA, #22D3EE);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
`;

const Sub = styled.p`
  color: ${({ theme }) => theme.colors.textDim};
  margin-top: 12px;
  font-size: 16px;
`;

export function SectionHead({ kicker, title, gradient, sub }) {
  return (
    <Head>
      {kicker && <Kicker>{kicker}</Kicker>}
      <Title>
        {title} {gradient && <span className="grad">{gradient}</span>}
      </Title>
      {sub && <Sub>{sub}</Sub>}
    </Head>
  );
}
